/* ANOKHI Redesign — cart drawer (Shopify AJAX) + mobile menu + rotators. Step 3. */
(function () {
  var I18N = window.AR_I18N || {}; // von layout/theme.liquid gesetzt (uebersetzt via 'ar.*' | t); Werte hier sind der bisherige DE-Fallback.
  var FREE = 10000; // cents (100 €)
  function eur(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
  function q(id) { return document.getElementById(id); }
  var TRASH = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7V4h6v3"/></svg>';
  // Zeilenpreis: bei Rabatt Prozent-Badge + Streichpreis über dem Endpreis
  function priceHtml(orig, now) {
    if (!(orig > now)) return '<div class="row"><b>' + eur(now) + '</b></div>';
    var pct = Math.round((1 - now / orig) * 100);
    return (pct > 0 ? '<span class="citem-pct">&minus;' + pct + ' %</span>' : '') + '<div class="row"><s>' + eur(orig) + '</s><b>' + eur(now) + '</b></div>';
  }
  // Leerer Warenkorb: Text + bis zu 4 Bestseller (window.AR_BS_CARDS aus ar-cart-drawer.liquid) + CTA
  function renderEmpty() {
    var cards = (window.AR_BS_CARDS || []).map(function (x) {
      return '<a href="' + esc(x.u) + '"><span class="cart-empty-ph"><img src="' + esc(x.img) + '" alt="" loading="lazy"></span><span class="xs-nm">' + esc(x.t) + '</span>' +
        '<span class="xs-pr">' + (x.c > x.p ? '<s>' + eur(x.c) + '</s>' : '') + '<span>' + eur(x.p) + '</span></span></a>';
    }).join('');
    return '<div class="cart-empty"><p>' + esc(I18N.emptyCartText || 'Dein Warenkorb ist noch leer.') + '</p>' +
      (cards ? '<div class="cart-empty-head">' + esc(I18N.emptyBestsellersHeading || 'Unsere Bestseller') + '</div><div class="cart-empty-grid">' + cards + '</div>' : '') +
      '<a class="btn-solid" href="/collections/all">' + esc(I18N.emptyCartCta || 'Unikate entdecken') + '</a></div>';
  }
  function esc(s) { return (s == null ? '' : '' + s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function render(cart) {
    var drawer = q('ar-cartDrawer'); if (!drawer) return;
    var items = cart.items || [];
    document.querySelectorAll('#ar-cartCount, .cart-ct').forEach(function (e) { e.textContent = cart.item_count; e.hidden = !cart.item_count; });
    var itemsEl = q('ar-cartItems'), foot = q('ar-cartFoot'), urg = q('ar-cartUrgency'),
        shipMsg = q('ar-shipMsg'), shipFill = q('ar-shipFill');
    var sub = cart.total_price;
    if (items.length) {
      if (foot) foot.style.display = 'block';
      if (urg) urg.style.display = 'flex';
      itemsEl.innerHTML = items.map(function (i) {
        var img = i.image || (i.featured_image && i.featured_image.url) || '';
        var url = esc(i.url || '');
        var thumb = img ? '<img class="thumb" src="' + esc(img) + '" alt="" loading="lazy">' : '';
        thumb = url ? '<a class="citem-link citem-ph" href="' + url + '" tabindex="-1" aria-hidden="true">' + thumb + '</a>' : '<span class="citem-ph">' + thumb + '</span>';
        var name = url ? '<a class="citem-link" href="' + url + '">' + esc(i.product_title) + '</a>' : esc(i.product_title);
        // Variante als „Farbe: Grau“ (Optionsname aus /cart.js), Default Title ausblenden
        var vlabel = (i.options_with_values || []).filter(function (o) { return o.value && o.value !== 'Default Title'; })
          .map(function (o) { return esc(o.name) + ': ' + esc(o.value.charAt(0).toUpperCase() + o.value.slice(1)); }).join(' · ');
        // Warenkorb-Rabatt (cart-level) anteilig auf die Zeile runterrechnen, plus evtl. line-level
        var base = i.final_line_price;
        var cd = cart.total_discount || 0, st = cart.items_subtotal_price || 0;
        var lineFinal = base - ((cd > 0 && st > 0) ? Math.round(base * cd / st) : 0);
        var k = esc(i.key);
        var isBest = window.AR_BESTSELLERS && window.AR_BESTSELLERS.indexOf(i.product_id) > -1;
        var bsFlag = isBest ? '<span class="citem-bs">' + esc(I18N.bestseller || 'Bestseller') + '</span>' : '';
        return '<div class="citem">' + thumb +
          '<div class="citem-mid">' + bsFlag + '<div class="nm">' + name + '</div>' +
          (vlabel ? '<div class="vr">' + vlabel + '</div>' : '') + '</div>' +
          '<div class="citem-side"><div class="citem-pr" data-vid="' + i.id + '" data-disc="' + (i.original_line_price > lineFinal ? 1 : 0) + '">' + priceHtml(i.original_line_price, lineFinal) + '</div>' +
          '<button class="citem-rm" type="button" data-key="' + k + '" aria-label="' + esc((I18N.removeItem || 'Entfernen') + ': ' + i.product_title) + '">' + TRASH + '</button></div></div>';
      }).join('');
      itemsEl.querySelectorAll('.citem-rm').forEach(function (b) {
        b.addEventListener('click', function () { b.disabled = true; change(b.getAttribute('data-key'), 0); });
      });
      renderXs(items);
      q('ar-cartSub').textContent = eur(sub);
      var shipEl = q('ar-shipCost');
      if (sub >= FREE) { shipEl.textContent = (I18N.freeShippingLabel || 'Kostenlos'); shipEl.className = 'free'; }
      else { shipEl.textContent = eur(490); shipEl.className = ''; }
      updateSavings(cart);
      if (sub >= FREE) { shipMsg.innerHTML = '<span class="ok">✓ ' + esc(I18N.freeShippingReached || 'Du erhältst kostenlosen Versand.') + '</span>'; shipFill.style.width = '100%'; }
      else { shipMsg.innerHTML = (I18N.freeShippingRemaining || 'Noch {amount} bis zum kostenlosen Versand').replace('{amount}', '<b>' + eur(FREE - sub) + '</b>'); shipFill.style.width = (sub / FREE * 100) + '%'; }
    } else {
      if (foot) foot.style.display = 'none';
      if (urg) urg.style.display = 'none';
      renderXs([]);
      itemsEl.innerHTML = renderEmpty();
      shipMsg.innerHTML = (I18N.freeShippingRemaining || 'Noch {amount} bis zum kostenlosen Versand').replace('{amount}', '<b>' + eur(FREE) + '</b>'); shipFill.style.width = '0%';
    }
  }

  // Savings = cart-level discounts + sale (compare_at) savings.
  // /cart.js lacks compare_at_price, so we fetch it per product.
  function updateSavings(cart) {
    var savRow = q('ar-savingsRow'), savVal = q('ar-savingsVal'); if (!savRow) return;
    var discountSav = (cart.original_total_price || cart.total_price) - cart.total_price;
    function show(total) {
      if (total > 0) { savRow.style.display = ''; savVal.textContent = '−' + eur(total); }
      else { savRow.style.display = 'none'; }
    }
    show(discountSav);
    var items = cart.items || []; if (!items.length) return;
    var handles = [];
    items.forEach(function (i) { if (handles.indexOf(i.handle) < 0) handles.push(i.handle); });
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).catch(function () { return null; });
    })).then(function (prods) {
      var cmap = {};
      prods.forEach(function (p) { if (p && p.variants) p.variants.forEach(function (v) { cmap[v.id] = v.compare_at_price; }); });
      var cs = 0;
      items.forEach(function (i) {
        var ca = cmap[i.id];
        if (!ca || ca <= i.price) return;
        cs += (ca - i.price) * i.quantity;
        // Streichpreis (compare_at) auf der Zeile zeigen, falls nicht schon ein Cart-Rabatt-Strich da ist
        var el = document.querySelector('.citem-pr[data-vid="' + i.id + '"]');
        if (el && el.getAttribute('data-disc') !== '1') {
          el.setAttribute('data-disc', '1');
          el.innerHTML = priceHtml(ca * i.quantity, i.final_line_price);
        }
      });
      show(discountSav + cs);
    }).catch(function () {});
  }
  // Cross-Selling „Nur noch für kurze Zeit“ (Outlet mit Streichpreis, aus ar-cart-drawer.liquid)
  function renderXs(items) {
    var box = q('ar-cartXs'), row = q('ar-cartXsRow'); if (!box || !row) return;
    var inCart = (items || []).map(function (i) { return i.product_id; });
    var list = (window.AR_XSELL || []).filter(function (x) { return inCart.indexOf(x.pid) === -1; }).slice(0, 7);
    if (!items || !items.length || !list.length) { box.style.display = 'none'; row.innerHTML = ''; return; }
    row.innerHTML = list.map(function (x) {
      var u = esc(x.u);
      return '<div class="xs-card"><a class="xs-img" href="' + u + '" tabindex="-1" aria-hidden="true"><img src="' + esc(x.img) + '" alt="" loading="lazy"></a>' +
        '<a class="xs-nm" href="' + u + '">' + esc(x.t) + '</a>' +
        '<div class="xs-pr"><s>' + eur(x.c) + '</s><span>' + eur(x.p) + '</span></div>' +
        '<button class="xs-add" type="button" data-vid="' + x.vid + '" aria-label="' + esc((I18N.xsellAddAria || '{title} in den Warenkorb').replace('{title}', x.t)) + '">+</button></div>';
    }).join('');
    row.querySelectorAll('.xs-add').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return; b.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-vid'), 10), quantity: 1 }] }) })
          .then(function (r) { return r.json(); }).then(function () { fetchCart(); }).catch(function () { b.disabled = false; });
      });
    });
    box.style.display = 'block';
  }
  function fetchCart(cb) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { render(c); if (cb) cb(c); });
  }
  function change(key, qty) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(render);
  }
  function openCart() {
    var drawer = q('ar-cartDrawer'), o = q('ar-cartOverlay'); if (!drawer) return;
    drawer.classList.add('open'); if (o) o.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); fetchCart();
  }
  function closeCart() {
    var drawer = q('ar-cartDrawer'), o = q('ar-cartOverlay');
    if (drawer) { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); } if (o) o.classList.remove('open');
  }
  function addToCart(form) {
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json(); }).then(function () { openCart(); }).catch(function () { form.submit(); });
  }

  function initMenu() {
    var b = q('ar-burger'), s = q('ar-mnScreen'); if (!s) return;
    function closeM() { s.classList.remove('open'); document.body.style.overflow = ''; }
    if (b) b.addEventListener('click', function () { s.classList.add('open'); document.body.style.overflow = 'hidden'; });
    var x = q('ar-mnX'); if (x) x.addEventListener('click', closeM);
    var mc = q('ar-mnCart'); if (mc) mc.addEventListener('click', function (e) { e.preventDefault(); closeM(); openCart(); });
    s.querySelectorAll('.mn-view a, .mn-flinks a').forEach(function (a) { a.addEventListener('click', closeM); });

    // zweite Ebene schiebt rein statt aufzuklappen
    var view = q('ar-mnView');
    if (view) {
      function backAll() {
        view.querySelectorAll('.mn-l2.on').forEach(function (p) { p.classList.remove('on'); });
        view.classList.remove('deep');
      }
      view.querySelectorAll('[data-mnopen]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var pane = view.querySelector('.mn-l2[data-mnpane="' + btn.getAttribute('data-mnopen') + '"]');
          if (!pane) return;
          pane.classList.add('on');
          view.classList.add('deep');
          pane.scrollTop = 0;
        });
      });
      view.querySelectorAll('[data-mnback]').forEach(function (btn) {
        btn.addEventListener('click', function (e) { e.preventDefault(); backAll(); });
      });
      // Menue schliessen setzt die Ebene zurueck, sonst oeffnet es beim naechsten Mal tief
      if (b) b.addEventListener('click', backAll);
      if (x) x.addEventListener('click', backAll);
    }
  }
  function initRotators() {
    var ann = document.querySelector('.announce');
    if (ann) {
      // Punkte inkl. Icon (innerHTML stammt aus dem eigenen Liquid-Markup der USP-Leiste)
      var msgs = [].map.call(ann.querySelectorAll(':scope > .ai'), function (s) { return s.innerHTML; });
      if (msgs.length > 1) {
        var rot = document.createElement('span'); rot.className = 'announce-rot ai'; rot.innerHTML = msgs[0]; ann.appendChild(rot);
        var i = 0; setInterval(function () { rot.style.opacity = '0'; setTimeout(function () { i = (i + 1) % msgs.length; rot.innerHTML = msgs[i]; rot.style.opacity = '1'; }, 260); }, 3000);
      }
    }
    var ts = document.querySelector('.tstrip');
    if (ts) {
      var t = ts.querySelectorAll('span');
      if (t.length > 1) { var k = 0; t[0].classList.add('is-active'); setInterval(function () { t[k].classList.remove('is-active'); k = (k + 1) % t.length; t[k].classList.add('is-active'); }, 3000); }
    }
  }
  // Galerie: ein Bilder-Track, den auf Desktop die Thumbnails und auf Mobile die Wischgeste steuert.
  // galleryApi haelt den aktiven Index, damit die Lightbox beim Oeffnen dasselbe Bild zeigt.
  var galleryApi = null;
  // stickyApi haelt die Sticky-Leiste an der gewaehlten Variante; wird von initVariantPicker() gefuettert.
  var stickyApi = null;
  function initGallery() {
    var track = q('ar-galTrack'); if (!track) return;
    var allSlides = [].slice.call(track.querySelectorAll('.gal-slide'));
    if (!allSlides.length) return;
    var allThumbs = [].slice.call(document.querySelectorAll('.thumbs img'));
    var prog = q('ar-galProgress');
    // Bei Varianten haelt der Track die Bilder ALLER Farben; sichtbar ist immer nur eine Gruppe.
    // slides/thumbs sind die gefilterte Sicht, all* die Gesamtmenge.
    var slides = allSlides, thumbs = allThumbs, bars = [];
    var idx = 0;

    function rebuildBars() {
      if (!prog) return;
      bars = [];
      if (slides.length < 2) { prog.innerHTML = ''; return; }
      var html = '';
      for (var n = 0; n < slides.length; n++) html += '<i></i>';
      prog.innerHTML = html;
      bars = [].slice.call(prog.querySelectorAll('i'));
    }
    function mark(i) {
      if (!slides.length) return;
      idx = Math.max(0, Math.min(slides.length - 1, i));
      thumbs.forEach(function (t, n) { t.classList.toggle('active', n === idx); });
      bars.forEach(function (b, n) { b.classList.toggle('is-on', n === idx); });
    }
    function goTo(i, smooth) {
      mark(i);
      track.scrollTo({ left: idx * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    // Wischen meldet die Position zurueck; requestAnimationFrame drosselt, damit das Scrollen fluessig bleibt.
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var w = track.clientWidth; if (!w) return;
        mark(Math.round(track.scrollLeft / w));
      });
    }, { passive: true });

    allThumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var n = thumbs.indexOf(t);
        if (n > -1) goTo(n);
      });
    });

    // Blendet aus, was einer anderen Variantengruppe zugeordnet ist. Bilder ohne
    // data-media-group gehoeren zu keiner Gruppe und bleiben immer sichtbar.
    function filterByGroup(group) {
      var key = (group || '').trim().toLowerCase();
      function keep(el) {
        var g = (el.getAttribute('data-media-group') || '').trim().toLowerCase();
        return !key || !g || g === key;
      }
      slides = allSlides.filter(function (el) { el.hidden = !keep(el); return !el.hidden; });
      thumbs = allThumbs.filter(function (el) { el.hidden = !keep(el); return !el.hidden; });
      // Kein Treffer waere ein leerer Bilderbereich - dann lieber alles zeigen als nichts.
      if (!slides.length) {
        allSlides.forEach(function (el) { el.hidden = false; });
        allThumbs.forEach(function (el) { el.hidden = false; });
        slides = allSlides; thumbs = allThumbs;
      }
      rebuildBars();
      goTo(0, false);
      if (galleryApi) galleryApi.slides = slides;
    }

    rebuildBars();
    mark(0);
    galleryApi = { slides: slides, index: function () { return idx; }, goTo: goTo, filterByGroup: filterByGroup };
  }

  // Variantenauswahl: Swatches fuer Farben, Dropdown fuer alles andere. Loest die Kombination
  // gegen die eingebettete Variantenliste auf und zieht Preis, Kaufbarkeit, Bestandshinweis
  // und Galerie nach. Die URL wird mitgeschrieben, damit Teilen und Zurueck die Wahl behalten.
  function initVariantPicker() {
    var box = document.querySelector('[data-ar-vpick]'); if (!box) return;
    var raw = box.querySelector('[data-ar-vp-data]');
    var variants = [];
    try { variants = JSON.parse(raw.textContent); } catch (e) { return; }
    if (!variants.length) return;

    var input = document.querySelector('[data-ar-variant-input]');
    var elPrice = document.querySelector('[data-ar-price]');
    var elCompare = document.querySelector('[data-ar-compare]');
    var elRow = document.querySelector('[data-ar-price-row]');
    var elSave = document.querySelector('[data-ar-save]');
    var elBuy = document.querySelector('[data-ar-buy]');
    var elBis = document.querySelector('[data-ar-bis]');
    var elUrg = document.querySelector('[data-ar-urgency]');
    var opts = [].slice.call(box.querySelectorAll('.vp-opt'));

    function chosen() {
      return opts.map(function (o) {
        var on = o.querySelector('[data-ar-vp-value].is-on');
        if (on) return on.getAttribute('data-value');
        var sel = o.querySelector('[data-ar-vp-select]');
        return sel ? sel.value : null;
      });
    }
    function findVariant(vals) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], hit = true;
        for (var n = 0; n < vals.length; n++) {
          if (vals[n] != null && v.options[n] !== vals[n]) { hit = false; break; }
        }
        if (hit) return v;
      }
      return null;
    }
    function apply() {
      var vals = chosen();
      var v = findVariant(vals);
      opts.forEach(function (o) {
        var cur = o.querySelector('[data-ar-vp-current]');
        var on = o.querySelector('[data-ar-vp-value].is-on');
        var sel = o.querySelector('[data-ar-vp-select]');
        if (cur) cur.textContent = on ? on.getAttribute('data-value') : (sel ? sel.value : '');
      });
      if (!v) return;
      if (input) input.value = v.id;
      // Merkliste-Herz folgt der Variante; gemerkt wird je Variante.
      var wish = document.querySelector('.buy [data-ar-wish]');
      if (wish) { wish.setAttribute('data-variant', v.id); wishPaint(); }
      if (elPrice && v.price) elPrice.textContent = v.price;
      if (elCompare) {
        if (v.compare) { elCompare.textContent = v.compare; elCompare.hidden = false; }
        else { elCompare.textContent = ''; elCompare.hidden = true; }
      }
      if (elRow) elRow.classList.toggle('is-sale', !!v.compare);
      // Die Ersparnis-Box wird nur versteckt, nicht neu berechnet: ihre Formatierung kommt
      // aus einem uebersetzten Liquid-String, den JS nicht zuverlaessig nachbaut.
      if (elSave) elSave.hidden = !v.compare;
      if (elBuy) elBuy.hidden = !v.available;
      if (elBis) elBis.hidden = v.available;
      if (stickyApi) stickyApi.update(v);
      if (elUrg) elUrg.hidden = !(v.available && v.tracked && v.qty > 0 && v.qty < 5);

      // Bildgruppe folgt der Farboption, sonst dem ersten Wert.
      var group = null;
      opts.forEach(function (o, n) {
        if (o.classList.contains('is-color') && vals[n]) group = vals[n];
      });
      if (group == null) group = vals[0];
      if (galleryApi && galleryApi.filterByGroup) galleryApi.filterByGroup(group);

      if (window.history && window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u);
      }
    }

    box.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-ar-vp-value]') : null;
      if (!b) return;
      var group = b.parentNode;
      [].slice.call(group.querySelectorAll('[data-ar-vp-value]')).forEach(function (x) {
        var on = x === b;
        x.classList.toggle('is-on', on);
        x.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      apply();
    });
    box.addEventListener('change', function (e) {
      if (e.target && e.target.hasAttribute('data-ar-vp-select')) apply();
    });
    // Pfeiltasten wandern durch die Gruppe, wie es die radiogroup-Rolle erwarten laesst.
    box.addEventListener('keydown', function (e) {
      var b = e.target.closest ? e.target.closest('[data-ar-vp-value]') : null;
      if (!b) return;
      var d = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1
            : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
      if (!d) return;
      e.preventDefault();
      var list = [].slice.call(b.parentNode.querySelectorAll('[data-ar-vp-value]'));
      var n = (list.indexOf(b) + d + list.length) % list.length;
      list[n].focus(); list[n].click();
    });

    apply();
  }
  // Eigener Bild-Zoom (Vanilla, ersetzt Prestige/photoswipe): Lightbox + Bildwechsel + Klick/Tap-Zoom mit Pan.
  function initZoom() {
    var ov = q('ar-zoom'), zi = q('ar-zoomImg');
    if (!ov || !zi || !galleryApi) return;
    // Nicht cachen: bei Varianten tauscht die Galerie ihre Slides, eine feste Liste
    // wuerde nach dem Wechsel die Bilder der alten Farbe zoomen.
    function currentImgs() {
      return galleryApi.slides.map(function (s) { return s.querySelector('img'); }).filter(Boolean);
    }
    if (!currentImgs().length) return;
    var idx = 0;
    function load(i) {
      var imgs = currentImgs();
      if (!imgs.length) return;
      idx = (i + imgs.length) % imgs.length;
      var im = imgs[idx];
      zi.src = im.getAttribute('data-zoom') || im.src;
      // Track mitziehen, damit nach dem Schliessen dasselbe Bild steht, das zuletzt zu sehen war.
      galleryApi.goTo(idx, false);
      zi.classList.remove('zoomed'); zi.style.transform = '';
    }
    function open() {
      load(galleryApi.index());
      ov.classList.add('open'); document.body.style.overflow = 'hidden';
    }
    function close() { ov.classList.remove('open'); document.body.style.overflow = ''; zi.classList.remove('zoomed'); zi.style.transform = ''; }
    function zoomTo(e) {
      var r = zi.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100, y = ((e.clientY - r.top) / r.height) * 100;
      zi.style.transformOrigin = Math.max(0, Math.min(100, x)) + '% ' + Math.max(0, Math.min(100, y)) + '%';
      zi.style.transform = 'scale(2.3)';
    }
    function go(d, e) { if (e) e.stopPropagation(); load(idx + d); }
    var btn = q('ar-zoomBtn'); if (btn) btn.addEventListener('click', open);
    // Delegiert statt pro Bild gebunden, damit auch spaeter eingeblendete Slides den Zoom oeffnen.
    var _tr = q('ar-galTrack');
    if (_tr) _tr.addEventListener('click', function (e) { if (e.target && e.target.tagName === 'IMG') open(); });
    zi.addEventListener('click', function (e) {
      e.stopPropagation();
      if (zi.classList.contains('zoomed')) { zi.classList.remove('zoomed'); zi.style.transform = ''; }
      else { zi.classList.add('zoomed'); zoomTo(e); }
    });
    zi.addEventListener('mousemove', function (e) { if (zi.classList.contains('zoomed')) zoomTo(e); });
    if (currentImgs().length > 1) ov.classList.add('has-nav');
    var prev = q('ar-zoomPrev'), next = q('ar-zoomNext');
    if (prev) prev.addEventListener('click', function (e) { go(-1, e); });
    if (next) next.addEventListener('click', function (e) { go(1, e); });
    ov.addEventListener('click', close);
    var cl = q('ar-zoomClose'); if (cl) cl.addEventListener('click', function (e) { e.stopPropagation(); close(); });
    document.addEventListener('keydown', function (e) {
      if (!ov.classList.contains('open')) return;
      if (e.key === 'Escape') close(); else if (e.key === 'ArrowLeft') go(-1); else if (e.key === 'ArrowRight') go(1);
    });
  }
  // Sticky Add-to-Cart: erscheint erst, wenn das Kaufformular nach OBEN aus dem Bild
  // gescrollt ist — nicht, solange es weiter unten noch auf seine Sichtbarkeit wartet.
  // Der Klick geht durch dasselbe Formular wie der normale Kaufbutton, damit Varianten-ID,
  // /cart/add.js und Cart-Drawer identisch bleiben.
  function initSticky() {
    var bar = q('ar-sticky'), form = q('ar-addForm'); if (!bar || !form) return;
    var add = bar.querySelector('[data-ar-sticky-add]');
    var price = bar.querySelector('[data-ar-sticky-price]');

    // inert statt nur transform: ausgeblendet darf die Leiste nicht im Tab-Fokus liegen.
    // Die Klasse am <html> und die gemessene Hoehe brauchen schwebende App-Widgets,
    // damit sie ausweichen koennen (siehe ar.css) — das Trusted-Shops-Badge sitzt mit
    // z-index 2147483646 sonst ueber dem Kaufbutton und deckt mobil dessen rechte
    // Haelfte ab. Gemessen statt fest verdrahtet, weil die Leiste mobil 59 und auf
    // Desktop 77 Pixel hoch ist.
    var shown = null;
    function setShown(on) {
      if (on === shown) return;
      shown = on;
      bar.classList.toggle('show', on);
      bar.inert = !on;
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      var r = document.documentElement;
      if (on) r.style.setProperty('--ar-sticky-h', bar.offsetHeight + 'px');
      r.classList.toggle('ar-sticky-on', on);
    }
    setShown(false);

    if (add) add.addEventListener('click', function () {
      if (add.disabled) return;
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });

    // Bewusst ein Scroll-Listener und kein IntersectionObserver: der IO meldet nur
    // Zustandswechsel der Ueberschneidung. Springt die Seite in einem Schritt von
    // "Formular unterhalb des Bildes" auf "oberhalb" (Ankerlink, Scroll-Restoration
    // beim Zurueck, Sprung zu #reviews), bleibt isIntersecting beide Male false und
    // der Observer schweigt — die Leiste bliebe aus. Der Positionsvergleich hier ist
    // zustandslos und stimmt immer. rAF drosselt auf einen Frame.
    // Am Footer wieder ausblenden — sonst klebt die Leiste ueber den Footer-Links und
    // ueber der letzten Sektion, in der es nichts mehr zu kaufen gibt. Gleiche Regel wie
    // in den anderen Shops: sichtbar nur, wenn das Kaufformular oben raus ist UND der
    // Footer noch nicht im Bild steht. Prestige/Impact loesen das mit einem
    // IntersectionObserver auf Formular + Footer; hier bleibt es aus dem Grund oben
    // (Sprungscrolls) ein zustandsloser Positionsvergleich. 12.09.2026
    var foot = document.querySelector('.ar-foot');
    var ticking = false;
    function sync() {
      ticking = false;
      var pastForm = form.getBoundingClientRect().bottom < 0;
      var footerVisible = foot ? foot.getBoundingClientRect().top < window.innerHeight : false;
      setShown(pastForm && !footerVisible);
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(sync);
    }, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();

    stickyApi = {
      update: function (v) {
        if (price && v.price) price.textContent = v.price;
        if (!add) return;
        add.disabled = !v.available;
        add.textContent = v.available ? (I18N.addToCart || 'In den Warenkorb') : (I18N.soldOut || 'Ausverkauft');
      }
    };
  }
  function initRecentlyViewed() {
    var KEY = 'ar_rv2', cur = null, pv = q('ar-pv-data');
    if (pv) { try { cur = JSON.parse(pv.textContent); } catch (e) {} }
    var list = []; try { list = JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) {}
    if (cur && cur.handle) {
      list = list.filter(function (x) { return x.handle !== cur.handle; });
      list.unshift(cur); list = list.slice(0, 12);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }
    var grid = q('ar-rv-grid'); if (!grid) return;
    var show = list.filter(function (x) { return !cur || x.handle !== cur.handle; }).slice(0, 4);
    if (!show.length) return;
    function rvStars(n) { var p = '<path d="M12 2.5l2.9 5.9 6.5.95-4.7 4.58 1.11 6.47L12 17.4l-5.81 3.05L7.3 13.98 2.6 9.4l6.5-.95L12 2.5z"/>', s = '<span class="ar-stars">'; for (var i = 1; i <= 5; i++) { s += '<svg viewBox="0 0 24 24" fill="' + (i <= n ? 'var(--ar-ink)' : 'rgba(0,0,0,.14)') + '" aria-hidden="true">' + p + '</svg>'; } return s + '</span>'; }
    grid.innerHTML = show.map(function (x) {
      var img = x.image ? '<a href="' + esc(x.url) + '"><img src="' + esc(x.image) + '" alt="" loading="lazy" style="width:100%;aspect-ratio:4/5;object-fit:cover;display:block"></a>' : '';
      var rt = x.rating ? '<div class="rt">' + rvStars(x.rating) + '<span>' + esc(x.rdisp || '') + '</span></div>' : '';
      return '<article class="card"><div class="ph">' + img + '</div><div class="body">' + rt + '<div class="nm"><a href="' + esc(x.url) + '">' + esc(x.title) + '</a></div><div class="pr">' + esc(x.price || '') + '</div></div></article>';
    }).join('');
    var sec = q('ar-rv'); if (sec) sec.style.display = '';
  }
  function init() {
    var co = q('ar-cartOpen'); if (co) co.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
    var cc = q('ar-cartClose'); if (cc) cc.addEventListener('click', closeCart);
    var ov = q('ar-cartOverlay'); if (ov) ov.addEventListener('click', closeCart);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
    document.querySelectorAll('form[action^="/cart/add"]').forEach(function (f) {
      f.addEventListener('submit', function (e) { e.preventDefault(); addToCart(f); });
    });
    initMenu(); initRotators(); initGallery(); initZoom(); initSticky(); initVariantPicker(); initSizeCompare(); initBackInStock(); initRecentlyViewed(); initSearch(); initLang(); initWishlist(); initQuickAdd(); fetchCart();
  }
  // Back in Stock: meldet die Adresse direkt bei Klaviyo an (Client-API, kein Onsite-JS).
  // Die Varianten-ID wird beim Absenden frisch aus dem Produkt-Formular gelesen, damit bei
  // Produkten mit mehreren Varianten die tatsaechlich gewaehlte abonniert wird.
  function initBackInStock() {
    var root = q('ar-bis'); if (!root) return;
    var dialog = q('ar-bisDialog'), email = q('ar-bisEmail'), news = q('ar-bisNews'),
        submit = q('ar-bisSubmit'), msg = q('ar-bisMsg');
    if (!dialog || !email || !submit || !msg) return;

    var companyId = root.dataset.companyId, listId = root.dataset.newsletterListId;
    var form = document.getElementById(root.dataset.formId);
    var strings = {};
    try { strings = JSON.parse(q('ar-bis-strings').textContent); } catch (e) { return; }
    var sending = false;

    function say(text, cls) { msg.textContent = text; msg.className = 'ar-bis__msg' + (cls ? ' ' + cls : ''); }
    function close() { dialog.close(); }

    q('ar-bisOpen').addEventListener('click', function () { say('', ''); dialog.showModal(); email.focus(); });
    q('ar-bisClose').addEventListener('click', close);
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
    email.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); send(); } });
    submit.addEventListener('click', send);

    function variantId() {
      var field = form && form.querySelector('[name="id"]');
      return field ? field.value : null;
    }

    async function send() {
      if (sending) return;
      var address = email.value.trim();
      if (!address || address.indexOf('@') < 1) { say(strings.invalid_email, 'is-error'); return; }
      var vid = variantId();
      if (!vid) { say(strings.no_variant, 'is-error'); return; }

      sending = true;
      submit.disabled = true;
      say(strings.sending, '');
      try {
        var res = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + companyId, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: { email: address } } },
                channels: ['EMAIL']
              },
              relationships: {
                variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + vid } }
              }
            }
          })
        });
        if (!res.ok && res.status !== 202) {
          console.error('Klaviyo BIS:', res.status, await res.text());
          say(strings.error_generic, 'is-error');
          return;
        }
        // Newsletter ist ein eigener Aufruf und darf die Anmeldung nicht scheitern lassen.
        if (news && news.checked && listId) {
          try {
            await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + companyId, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
              body: JSON.stringify({
                data: {
                  type: 'subscription',
                  attributes: {
                    custom_source: 'Back in Stock Formular',
                    profile: { data: { type: 'profile', attributes: { email: address } } }
                  },
                  relationships: { list: { data: { type: 'list', id: listId } } }
                }
              })
            });
          } catch (subErr) { console.warn('Klaviyo Newsletter:', subErr); }
        }
        say(strings.success, 'is-ok');
        email.value = '';
        setTimeout(close, 2600);
      } catch (err) {
        console.error('Klaviyo BIS Netzwerk:', err);
        say(strings.error_network, 'is-error');
      } finally {
        sending = false;
        submit.disabled = false;
      }
    }
  }
  // Größenvergleich: misst natürliche Breite und skaliert die Grafik so, dass sie
  // immer in den Container passt — egal wie groß die Tasche ist. Nur runter, nie hoch.
  function initSizeCompare() {
    var fit = q('ar-scFit'), stage = q('ar-scStage');
    if (!fit || !stage) return;
    stage.classList.add('is-fit');
    function fitNow() {
      stage.style.transform = 'translateX(-50%) scale(1)';
      var natW = stage.offsetWidth, natH = stage.offsetHeight, avail = fit.clientWidth;
      var s = (natW > 0 && avail < natW) ? avail / natW : 1;
      stage.style.transform = 'translateX(-50%) scale(' + s + ')';
      fit.style.height = Math.ceil(natH * s) + 'px';
    }
    fitNow();
    window.addEventListener('resize', fitNow);
    window.addEventListener('load', fitNow);
  }
  function initLang() {
    var widgets = document.querySelectorAll('[data-ar-lang]');
    if (!widgets.length) return;
    widgets.forEach(function (w) {
      var btn = w.querySelector('.ar-lang-toggle'); if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = w.classList.toggle('open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        widgets.forEach(function (o) { if (o !== w) { o.classList.remove('open'); var b = o.querySelector('.ar-lang-toggle'); if (b) b.setAttribute('aria-expanded', 'false'); } });
      });
    });
    document.addEventListener('click', function (e) {
      widgets.forEach(function (w) { if (!w.contains(e.target)) { w.classList.remove('open'); var b = w.querySelector('.ar-lang-toggle'); if (b) b.setAttribute('aria-expanded', 'false'); } });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') widgets.forEach(function (w) { w.classList.remove('open'); var b = w.querySelector('.ar-lang-toggle'); if (b) b.setAttribute('aria-expanded', 'false'); });
    });
  }
  function initSearch() {
    var ov = q('ar-searchOverlay'); if (!ov) return;
    var input = q('ar-searchInput'), body = q('ar-searchResults');
    var panel = ov.querySelector('.ar-search-panel');
    var popular = (ov.getAttribute('data-ar-popular') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var lastFocus = null, activeTab = 'products', lastData = null, lastQuery = '';

    // Panel/Backdrop setzen direkt unter dem sticky Header an (nicht unter der scrollenden
    // Promo/Announce-Leiste) — header.site.getBoundingClientRect().bottom ist bei sticky
    // Header immer die aktuell sichtbare Unterkante, egal ob am Seitenanfang oder gescrollt.
    function setHeaderTop() {
      var hdr = document.querySelector('.ar-root header.site');
      if (!hdr) return;
      var b = Math.max(hdr.getBoundingClientRect().bottom, 0);
      ov.style.setProperty('--ar-sh-top', b + 'px');
    }

    function focusablesIn(el) {
      return Array.prototype.slice.call(el.querySelectorAll('button, [href], input, [tabindex]:not([tabindex="-1"])')).filter(function (n) {
        return !n.disabled && n.offsetParent !== null;
      });
    }

    function open() {
      lastFocus = document.activeElement;
      setHeaderTop();
      ov.classList.add('open');
      ov.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var qv = input.value.trim();
      if (qv.length >= 2) suggest(qv); else renderPopular();
      setTimeout(function () { input.focus(); }, 60);
    }
    function close() {
      ov.classList.remove('open');
      ov.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }
    document.querySelectorAll('[data-ar-search]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); var mn = q('ar-mnScreen'); if (mn) mn.classList.remove('open'); open(); });
    });
    var cl = q('ar-searchClose'); if (cl) cl.addEventListener('click', close);
    ov.addEventListener('click', function (e) { if (e.target.hasAttribute('data-ar-search-backdrop')) close(); });
    document.addEventListener('keydown', function (e) {
      if (!ov.classList.contains('open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var f = focusablesIn(panel);
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    window.addEventListener('resize', function () { if (ov.classList.contains('open')) setHeaderTop(); });

    // Gleiche Treffer-Logik wie sections/ar-search.liquid: downcase + ae/oe/ue/ss-Faltung
    // (auf Titel UND Suchbegriff, daher beidseitig tolerant), Woerter < 2 Zeichen ignoriert.
    function normSearch(s) { return (s == null ? '' : '' + s).toLowerCase().replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss'); }
    function wordsSearch(s) { return normSearch(s).split(/\s+/).filter(function (w) { return w.length >= 2; }); }
    function isExactTitle(title, qWords) {
      if (!qWords.length) return false;
      var nt = normSearch(title);
      return qWords.every(function (w) { return nt.indexOf(w) !== -1; });
    }
    // Preise aus /search/suggest.json kommen als Dezimalstring in Shopwaehrung (kein Cent-Wert,
    // anders als cart.js), daher eigene de-DE-Formatierung statt der eur()-Helper der Cart-Drawer.
    function fmtPrice(v) {
      var n = parseFloat(v);
      if (isNaN(n)) return '';
      return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }
    // Lange SEO-Kategorietitel ("Halbmond Tasche & Hobo Bags – ...") auf den Teil vor
    // " – " kuerzen, wie in den langen Kategorie-Titeln ueblich.
    function collTitle(t) {
      var s = '' + (t == null ? '' : t);
      var i = s.indexOf(' – ');
      return (i > -1 ? s.slice(0, i) : s).trim();
    }

    function chipsHtml(heading, list) {
      if (!list.length) return '';
      var h = heading ? '<div class="ars-popular-h">' + esc(heading) + '</div>' : '';
      var chips = list.map(function (t) { return '<button type="button" class="ars-chip" data-ar-chip="' + esc(t) + '">' + esc(t) + '</button>'; }).join('');
      return h + '<div class="ars-chips">' + chips + '</div>';
    }
    function bindChips() {
      body.querySelectorAll('[data-ar-chip]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = b.getAttribute('data-ar-chip');
          input.value = v;
          input.focus();
          suggest(v);
        });
      });
    }
    function renderPopular() {
      lastData = null; lastQuery = '';
      body.innerHTML = chipsHtml(I18N.popularHeading || 'Beliebte Suchen', popular);
      bindChips();
    }

    function productCard(p) {
      var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
      var imghtml = img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '';
      var price = p.price != null ? p.price : p.price_min;
      var cmp = (p.compare_at_price_max && parseFloat(p.compare_at_price_max) > 0) ? p.compare_at_price_max : p.compare_at_price_min;
      var isSale = cmp && price != null && parseFloat(cmp) > parseFloat(price);
      var priceHtml = '<span class="ars-price' + (isSale ? ' is-sale' : '') + '">' + (isSale ? '<s>' + fmtPrice(cmp) + '</s>' : '') + fmtPrice(price) + '</span>';
      var type = p.product_type ? '<span class="ars-type">' + esc(p.product_type) + '</span>' : '';
      return '<a class="ars-card" href="' + esc(p.url) + '">' +
        '<span class="ph">' + imghtml + '</span>' +
        '<span class="ars-info"><span class="ars-row"><span class="ars-name">' + esc(p.title) + '</span>' + priceHtml + '</span>' + type + '</span>' +
        '</a>';
    }

    function tabsHtml() {
      return '<div class="ars-tabs" role="tablist" aria-label="' + esc(I18N.searchResultsAria || 'Suchergebnisse') + '">' +
        '<button type="button" class="ars-tab" id="ars-tab-products" role="tab" aria-selected="' + (activeTab === 'products') + '" aria-controls="ars-panel-products" tabindex="' + (activeTab === 'products' ? '0' : '-1') + '">' + esc(I18N.tabProducts || 'Produkte') + '</button>' +
        '<button type="button" class="ars-tab" id="ars-tab-collections" role="tab" aria-selected="' + (activeTab === 'collections') + '" aria-controls="ars-panel-collections" tabindex="' + (activeTab === 'collections' ? '0' : '-1') + '">' + esc(I18N.tabCollections || 'Kategorien') + '</button>' +
        '</div>';
    }
    function bindTabs() {
      var tabs = Array.prototype.slice.call(body.querySelectorAll('.ars-tab'));
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { activateTab(t.id === 'ars-tab-products' ? 'products' : 'collections'); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var next = e.key === 'ArrowRight' ? tabs[(i + 1) % tabs.length] : tabs[(i - 1 + tabs.length) % tabs.length];
          activateTab(next.id === 'ars-tab-products' ? 'products' : 'collections');
        });
      });
    }
    function activateTab(name) {
      activeTab = name;
      if (lastData) render(lastData, lastQuery);
      var btn = q('ars-tab-' + name);
      if (btn) btn.focus();
    }

    function suggest(qv) {
      // resources[limit] = 10 = erlaubtes Maximum der Shopify Predictive-Search-API für diesen Resource-Typ.
      fetch('/search/suggest.json?q=' + encodeURIComponent(qv) + '&resources[type]=product,collection&resources[limit]=10&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (d) { render(d, qv); })
        .catch(function () { });
    }
    function render(d, qv) {
      lastData = d; lastQuery = qv;
      var r = (d.resources && d.resources.results) || {};
      var qWords = wordsSearch(qv);
      // exakte Titel-Treffer (alle Suchwoerter als Teilstring enthalten) zuerst, Rest danach;
      // max 5 Karten (Desktop-Rasterbreite = Mobile-Listenlimit).
      var prods = (r.products || []).slice().sort(function (a, b) {
        var am = isExactTitle(a.title, qWords) ? 0 : 1, bm = isExactTitle(b.title, qWords) ? 0 : 1;
        return am - bm;
      }).slice(0, 5);
      var colls = (r.collections || []).slice(0, 10);

      if (!prods.length && !colls.length) {
        body.innerHTML = '<div class="ars-empty">' + esc((I18N.noResultsFor || 'Keine Treffer für „{query}“.').replace('{query}', qv)) + '</div>' + chipsHtml(I18N.popularHeading || 'Beliebte Suchen', popular);
        bindChips();
        return;
      }
      if (activeTab === 'collections' && !colls.length) activeTab = 'products';
      if (activeTab === 'products' && !prods.length) activeTab = 'collections';

      var html = tabsHtml();
      html += '<div id="ars-panel-products" role="tabpanel" aria-labelledby="ars-tab-products"' + (activeTab === 'products' ? '' : ' hidden') + '>';
      html += prods.length ? '<div class="ars-grid">' + prods.map(productCard).join('') + '</div>' : '<div class="ars-empty">' + esc(I18N.noMatchingProducts || 'Keine passenden Produkte.') + '</div>';
      html += '</div>';
      html += '<div id="ars-panel-collections" role="tabpanel" aria-labelledby="ars-tab-collections"' + (activeTab === 'collections' ? '' : ' hidden') + '>';
      html += colls.length ? '<div class="ars-coll-list">' + colls.map(function (c) { return '<a class="ars-coll" href="' + esc(c.url) + '">' + esc(collTitle(c.title)) + '</a>'; }).join('') + '</div>' : '<div class="ars-empty">' + esc(I18N.noMatchingCollections || 'Keine passenden Kategorien.') + '</div>';
      html += '</div>';
      html += '<a class="btn-solid ars-cta" href="/search?q=' + encodeURIComponent(qv) + '">' + esc(I18N.viewAllResults || 'Alle Ergebnisse anzeigen') + '</a>';
      body.innerHTML = html;
      bindTabs();
    }

    var t;
    if (input) input.addEventListener('input', function () {
      clearTimeout(t); var qv = input.value.trim();
      if (qv.length < 2) { renderPopular(); return; }
      t = setTimeout(function () { suggest(qv); }, 230);
    });
  }

  // Merkliste: liegt nur im Browser (localStorage), kein Konto, keine App. Eintrag je Variante:
  // {v: Varianten-ID, h: Produkt-Handle, p: Produkt-ID, t: Zeitpunkt}. Der Handle reicht, um auf der
  // Merkliste-Seite die Produktdaten ueber /products/<handle>.js zu holen.
  var WL_KEY = 'ar_wishlist';
  function wishRead() {
    try { var a = JSON.parse(localStorage.getItem(WL_KEY) || '[]'); return Array.isArray(a) ? a.filter(function (x) { return x && x.v && x.h; }) : []; }
    catch (e) { return []; }
  }
  function wishWrite(list) { try { localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch (e) {} wishSync(list); }
  // Aktuelle Merkliste ins Klaviyo-Profil (nur bei Profilen, die Klaviyo kennt). Die Flow-Mails lesen daraus
  // die Varianten-IDs und holen Name, Bild und Preis beim Versand frisch aus dem Shopify-Katalog.
  function wishSync(list) {
    var k = window.klaviyo || (window.klaviyo = []);
    k.push(['identify', { 'Merkliste': list.slice(0, 6).map(function (x) { return String(x.v); }), 'Merkliste Anzahl': list.length }]);
  }
  function wishHas(list, vid) { for (var i = 0; i < list.length; i++) if (String(list[i].v) === String(vid)) return true; return false; }
  function wishPaint() {
    var list = wishRead();
    document.querySelectorAll('[data-ar-wish]').forEach(function (b) {
      var on = wishHas(list, b.getAttribute('data-variant'));
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-ar-wish-count]').forEach(function (e) { e.textContent = list.length; e.hidden = !list.length; });
  }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  // Klaviyo Onsite-Ereignis fuer den Merkliste-Flow. Kommt nur bei Besuchern an, die Klaviyo bereits kennt.
  function wishTrack(item) {
    fetch(root() + 'products/' + encodeURIComponent(item.h) + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (p) {
        var v = (p.variants || []).filter(function (x) { return String(x.id) === String(item.v); })[0] || {};
        var img = (v.featured_image && v.featured_image.src) || p.featured_image || '';
        var k = window.klaviyo || (window.klaviyo = []);
        k.push(['track', 'Added to Wishlist', {
          ProductID: p.id, VariantID: v.id, ProductName: p.title, VariantName: v.public_title || '',
          Price: (v.price || p.price) / 100, CompareAtPrice: v.compare_at_price ? v.compare_at_price / 100 : null,
          URL: location.origin + p.url, ImageURL: img.indexOf('//') === 0 ? 'https:' + img : img, Available: !!v.available
        }]);
      }).catch(function () {});
  }
  function wishToggle(b) {
    var vid = b.getAttribute('data-variant'), h = b.getAttribute('data-handle'); if (!vid || !h) return;
    var list = wishRead();
    if (wishHas(list, vid)) list = list.filter(function (x) { return String(x.v) !== String(vid); });
    else { var item = { v: String(vid), h: h, p: b.getAttribute('data-product') || '', t: Date.now() }; list.unshift(item); wishTrack(item); }
    wishWrite(list); wishPaint();
    if (b.closest('[data-ar-wishlist]')) renderWishlistPage();
  }
  function renderWishlistPage() {
    var box = document.querySelector('[data-ar-wishlist]'); if (!box) return;
    var empty = document.querySelector('[data-ar-wishlist-empty]');
    var list = wishRead();
    if (!list.length) { box.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    // Karten kommen als fertiges HTML aus templates/product.wishcard.liquid, also exakt die regulaere Produktkarte.
    Promise.all(list.map(function (it) {
      return fetch(root() + 'products/' + encodeURIComponent(it.h) + '?view=wishcard&variant=' + encodeURIComponent(it.v))
        .then(function (r) { if (r.status === 404) return 'gone'; return r.ok ? r.text() : null; }).catch(function () { return null; })
        .then(function (html) {
          if (html === 'gone') { it.gone = true; return ''; }
          if (!html || html.indexOf('wl-item') < 0) return '';
          // Unbekannte Variante: Shopify faellt auf die Standardvariante zurueck, dann gilt der Eintrag als weg.
          if (html.indexOf('data-variant="' + it.v + '"') < 0) { it.gone = true; return ''; }
          return html;
        });
    })).then(function (cards) {
      // Geloeschte Produkte oder Varianten fliegen aus der Liste, sonst zaehlt der Header sie weiter mit.
      if (list.some(function (x) { return x.gone; })) wishWrite(wishRead().filter(function (x) { return !list.some(function (g) { return g.gone && String(g.v) === String(x.v); }); }));
      var html = cards.join('');
      box.innerHTML = html ? '<section class="grid wl-grid">' + html + '</section>' : '';
      if (empty) empty.hidden = !!html;
      wishPaint();
    });
  }
  // Mail-Link: /pages/merkliste?add=<handle>:<variantId>,<handle>:<variantId> uebernimmt die Eintraege auf einem
  // anderen Geraet. Union ohne Dubletten, vorhandene bleiben, neue kommen nach vorn. Kein Klaviyo-Ereignis dafuer.
  function wishAdopt() {
    if (!document.querySelector('[data-ar-wishlist]')) return;
    var m = /[?&]add=([^&#]*)/.exec(location.search); if (!m) return;
    var parts; try { parts = decodeURIComponent(m[1]).split(','); } catch (e) { parts = []; }
    var list = wishRead(), add = [], seen = {};
    parts.slice(0, 12).forEach(function (s) {
      var q = s.split(':'), h = q[0], v = q[1];
      if (q.length !== 2 || !/^[a-z0-9-]+$/.test(h) || !/^\d+$/.test(v) || seen[v] || wishHas(list, v)) return;
      seen[v] = 1; add.push({ v: v, h: h, p: '', t: Date.now() });
    });
    if (add.length) wishWrite(add.concat(list));
    // Parameter aus der Adresse nehmen, damit ein Neuladen nichts erneut uebernimmt.
    try { history.replaceState(null, '', location.pathname + location.search.replace(/([?&])add=[^&]*&?/, '$1').replace(/[?&]$/, '') + location.hash); } catch (e) {}
  }
  function initWishlist() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-ar-wish]');
      if (b) { e.preventDefault(); wishToggle(b); return; }
      var add = e.target.closest && e.target.closest('.wl-add');
      if (add && !add.disabled) {
        add.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(add.getAttribute('data-vid'), 10), quantity: 1 }] }) })
          .then(function (r) { return r.json(); }).then(function () { add.disabled = false; openCart(); }).catch(function () { add.disabled = false; });
      }
    });
    // Andere Tabs halten Zaehler und Herzen synchron.
    window.addEventListener('storage', function (e) { if (e.key === WL_KEY) { wishPaint(); renderWishlistPage(); } });
    wishAdopt(); wishPaint(); renderWishlistPage();
    // Einmal pro Sitzung abgleichen: wer erst nach dem Merken ueber einen Mail-Link kommt, ist dann bekannt.
    try { if (!sessionStorage.getItem('ar_wl_sync') && wishRead().length) { wishSync(wishRead()); sessionStorage.setItem('ar_wl_sync', '1'); } } catch (e) {}
  }
  // Schnellkauf aus der Produktkachel (ar-product-card.liquid). Position bekommt die versteckte
  // Eigenschaft _quelle=Kachel (steht in der Bestellung, nicht im Checkout), damit messbar ist,
  // wie oft der Knopf zum Kauf fuehrt. Clarity-Events nur, wenn Clarity geladen ist.
  function qaTrack(n) { try { if (window.clarity) window.clarity('event', n); } catch (e) {} }
  function qaClose(keep) {
    document.querySelectorAll('[data-ar-qa-pick]').forEach(function (p) { if (p !== keep) p.hidden = true; });
  }
  function qaAdd(b) {
    if (b.disabled) return; b.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-vid'), 10), quantity: 1, properties: { _quelle: 'Kachel' } }] }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { b.disabled = false; qaClose(); qaTrack('kachel_schnellkauf'); openCart(); })
      .catch(function () {
        // z. B. gerade ausverkauft: auf die Produktseite statt still nichts zu tun
        b.disabled = false; var a = b.closest('.card') && b.closest('.card').querySelector('a[href]'); if (a) location.href = a.href;
      });
  }
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var t = e.target; if (!t || !t.closest) return;
      var b = t.closest('[data-ar-qa]');
      if (b) {
        e.preventDefault();
        if (b.hasAttribute('data-vid')) { qaAdd(b); return; }
        var pick = b.parentNode.querySelector('[data-ar-qa-pick]'); if (!pick) return;
        qaClose(pick); pick.hidden = !pick.hidden; if (!pick.hidden) qaTrack('kachel_farbwahl');
        return;
      }
      var o = t.closest('[data-ar-qa-opt]'); if (o) { e.preventDefault(); qaAdd(o); return; }
      if (t.closest('[data-ar-qa-close]')) { e.preventDefault(); qaClose(); return; }
      if (!t.closest('[data-ar-qa-pick]')) qaClose();
      if (t.closest('.card a[href]')) qaTrack('kachel_klick');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
